import 'rc-slider/assets/index.css';

import PropTypes from 'prop-types';
import React from 'react';

import { Button, ButtonIcon, Footer } from '@sonyged/ext-proc';

import Constants from './Constants';

export default class SelectSettingContent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={'proc-ice-field-content select-setting'}>
        <div className={`proc-contents padding research-bg-color`}>
          <div className={`proc-outer`}>
            <div className={'proc-inner small status'}>
              <div className="header">
                <div className="left">
                  <div className={'weather secondary100-fill-color'}>
                    {Constants.getWetherSvg(this.props.iceCtx.weather)}
                  </div>
                  <div className={'temperature secondary100-color'}>
                    <span className={'proc-huge-font'}>{this.props.iceCtx.temperature}</span>
                    <span className={'proc-medium-font'}>ど</span>
                  </div>
                </div>
                <div className="center">
                  <img className="image" src={Constants.getStatusWagonIcon(this.props.wagon)} />
                </div>
              </div>
            </div>
          </div>
          <div className={`setting-container gray10-bg-color`}>
            <div className={'proc-outer'}>
              <div className={'proc-inner small'}>
                <div className={'title gray100-color center-aligned proc-medium-font'}>ひとつだけ かえて みよう</div>

                <div className={`proc-image-selection-container white`}>
                  <div
                    className={`images-container relative secondary20-after-border-bottom-color ${
                      this.props.changableSettingChange === 0 ? 'selected' : ''
                    }`}
                  >
                    <img
                      src={Constants.getPlaceIcon(this.props.iceCtx.place)}
                      className={`image ${this.props.changableSettingChange === 0 ? 'selected' : ''}`}
                      onClick={this.props.changableSettingChange === 0 ? null : this._onSettingChange.bind(this, 0)}
                    />
                    <div className={'title proc-small-font'}>ばしょ</div>
                  </div>
                  <div
                    className={`images-container relative secondary20-after-border-bottom-color ${
                      this.props.changableSettingChange === 1 ? 'selected' : ''
                    }`}
                  >
                    <img
                      src={Constants.getIceImage(this.props.iceCtx.ice)}
                      className={`image ${this.props.changableSettingChange === 1 ? 'selected' : ''}`}
                      onClick={this.props.changableSettingChange === 1 ? null : this._onSettingChange.bind(this, 1)}
                    />
                    <div className={'title proc-small-font'}>アイス</div>
                  </div>
                  <div
                    className={`images-container relative secondary20-after-border-bottom-color ${
                      this.props.changableSettingChange === 2 ? 'selected' : ''
                    }`}
                  >
                    <div
                      className={`image price gray30-color ${
                        this.props.changableSettingChange === 2 ? 'selected' : ''
                      }`}
                      onClick={this.props.changableSettingChange === 2 ? null : this._onSettingChange.bind(this, 2)}
                    >
                      {this.props.iceCtx.price}
                    </div>
                    <div className={'title proc-small-font'}>ねだん</div>
                  </div>
                </div>
                <div className={'hint proc-small-font white-bg-color gray100-color'}>{this._renderHint()}</div>
              </div>
            </div>
          </div>
        </div>
        <Footer.nav className="gray10-bg-color" shadow={false} navItem={this._renderPreviousButton()}>
          <Button.attention onClick={this.props.onNextClick}>つぎへ</Button.attention>
        </Footer.nav>
      </div>
    );
  }

  _renderHint() {
    if (this.props.changableSettingChange === 0) {
      return 'ばしょに よって とおる おきゃくさんが ちがうよ。';
    } else if (this.props.changableSettingChange === 1) {
      return 'おとなと こどもでは たべたい アイスが ちがうよ。';
    } else {
      return 'アイスが たべたい ひとは たかくても かって くれるよ。';
    }
  }

  _renderPreviousButton() {
    if (!this.props.onPreviousClick) {
      return <span />;
    }
    return (
      <Button.normal onClick={this.props.onPreviousClick}>
        <ButtonIcon.back />
      </Button.normal>
    );
  }

  _onSettingChange(t) {
    this.props.onChangableSettingChange(t);
  }
}

SelectSettingContent.propTypes = {
  iceCtx: PropTypes.object,
  changableSettingChange: PropTypes.number,
  wagon: PropTypes.number,
  onPreviousClick: PropTypes.func,
  onNextClick: PropTypes.func,
  onWagonChange: PropTypes.func,
  onChangableSettingChange: PropTypes.func,
};

SelectSettingContent.defaultProps = {};
